var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32.4 16.187",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 1.91,
    y1: 11.659,
    x2: 9.821,
    y2: 3.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#c757bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#cd5ca9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#e8744f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#f88316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#ff8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#00afff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#5282ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945dff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 3.239,
    y1: 6.189,
    x2: 5.944,
    y2: 3.484,
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#B",
    id: "D",
    x1: 6.054,
    y1: 13.878,
    x2: 9.91,
    y2: 10.022
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.129)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.236 5.892h.994v1.976l1.834-1.976h1.2L15.424 7.8l1.924 2.602h-1.195l-1.4-1.924-.523.542v1.382h-.994zM16.82 8.7v-.013c0-.994.8-1.8 1.88-1.8 1.072 0 1.866.794 1.866 1.8V8.7c0 .994-.8 1.8-1.88 1.8-1.072 0-1.866-.794-1.866-1.8zm2.776 0v-.013c0-.5-.368-.956-.9-.956-.562 0-.898.433-.898.943v.013c0 .5.368.956.9.956.562 0 .897-.433.897-.943z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.836 9.43V7.8h-.413v-.84h.413v-.885h.98v.885h.814v.84h-.814v1.48c0 .226.097.336.316.336a.998.998 0 0 0 .484-.123v.788c-.207.123-.445.2-.775.2-.6 0-1.007-.24-1.007-1.04zm2.077-3.732h.98v4.713h-.98zm1.336 0h1.033v.872H24.25zm.026 1.253h.98v3.46h-.98zm1.355 0h.98v.49c.226-.29.517-.555 1.014-.555.743 0 1.175.49 1.175 1.285v2.24h-.98V8.48c0-.465-.22-.704-.594-.704s-.613.24-.613.704v1.93h-.98z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.61 3.843L3.34 8.33v4.013l4.262-4.27 4.24-4.232z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34 12.344l4.262-4.27 4.24 4.27z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34 3.843H7.61L3.34 8.33z",
    fill: "url(#C)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.f710898f1d7cafe05eed518a3c801406.svg";
export { ForwardRef as ReactComponent };